import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Table,
  Badge,Modal, ModalHeader,  ModalBody, ModalFooter 
} from "reactstrap";

import { useState } from "react";


const Communication = () => {
  const [templateDataModal, setTemplateDataModal] = useState(false);

  const [selectedTemplateData, setSelectedTemplateData] = useState("");

  const templateDataHandle = (e) => {
    e.preventDefault();
    setSelectedTemplateData(e.currentTarget.dataset.data)
    setTemplateDataModal(true);
  };
  const closeTemplateDataModal = () => {
    setTemplateDataModal(false);
  };


  return (
    <>


<Modal id="templateDataModal" isOpen={templateDataModal} toggle={closeTemplateDataModal} size="lg" >
        <ModalHeader>
        Template Data
        </ModalHeader>
        <ModalBody>
            <Row>
              <Col lg="12" className="mb-4">
                    {selectedTemplateData}
                </Col>
            </Row>
                
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={closeTemplateDataModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      
          
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Communication Logs</h3>
                  </Col>
                  
                </Row>
              </CardHeader>
              <CardBody>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Create Date</th>
                    <th scope="col">Channel</th>
                    <th scope="col">Template ID</th>
                    <th scope="col">Template Data</th>
                    <th scope="col">Status</th>
                    <th scope="col">Error</th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>2025-01-01 11:11:34</td>
                    <td>SMS</td>
                    <td>LOAN_DISBURSED</td>
                    <td><a className="clickable" onClick={templateDataHandle} data-data={JSON.stringify({"amount":3000, "processing_fees":388})}>View</a></td>

                    <td>
                      <Badge color="" className="badge-dot mr-4">
                        <i className="bg-green" />
                        Delivered
                      </Badge>
                    </td>
                    <td>{" "}</td> 
                  </tr>

                  <tr>
                    <td>2025-01-01 11:11:34</td>
                    <td>SMS</td>
                    <td>LOAN_DISBURSED</td>
                    <td><a className="clickable" onClick={templateDataHandle} data-data={JSON.stringify({"amount":3000, "processing_fees":388})}>View</a></td>

                    <td>
                      <Badge color="" className="badge-dot mr-4">
                        <i className="bg-danger" />
                        Error
                      </Badge>
                    </td>
                    <td>
                      Out of network
                    </td> 

                  </tr>
                  
                  
                  
                </tbody>
              </Table>
                
              </CardBody>
            </Card>
          
        
    </>
  );
};

export default Communication;
